import {styled} from "@mui/system";
import {Box, Typography} from "@mui/material";
import backgroundUrl from "../../assets/blume_bg1.jpg";

export const BackgroundWrapper = styled(Box)({
    height: '100%',
})

export const Header = styled(Typography)({
    color: "var(--brand-default-color)",
    fontSize: '57px',
    textAlign: 'left',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '64px',
    letterSpacing: '-0.25px',
    textShadow: '0px 1px 3px rgba(0,0,0,0.30), 0px 4px 8px rgba(255, 255, 255, 0.15)',
    paddingBottom: '40px',
})

export const Body = styled(Header)({
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.5px',
    paddingBottom: '80px'
})

export const ContentWrapper = styled(Box)({
    paddingLeft: '72px',
    width: '560px',
    marginTop: '100px'
})
